import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AssessmentSettingsModalComponent } from "@/components/assessment/assessment-settings-modal/assessment-settings-modal.component";
import { ContextualNavService } from "@/_services/contextual-nav.service";

@Component({
    selector: "app-create-assessment",
    styleUrls: ["./create-assessment.component.scss"],
    templateUrl: "./create-assessment.component.html",
})
export class CreateAssessmentComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        private modalService: NgbModal,
        private contextualNavService: ContextualNavService,
    ) {}

    ngOnInit() {
        this.contextualNavService.onAddAction$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.createNewAssessmentForm());
    }

    createNewAssessmentForm() {
        const loading = this.modalService.open(
            AssessmentSettingsModalComponent,
            { backdrop: true, keyboard: true },
        );
        const component =
            loading.componentInstance as AssessmentSettingsModalComponent;
        component.assessment = null;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
